import { render, staticRenderFns } from "./sysTransLogs.vue?vue&type=template&id=1ea92f55&scoped=true"
import script from "./sysTransLogs.vue?vue&type=script&lang=js"
export * from "./sysTransLogs.vue?vue&type=script&lang=js"
import style0 from "./sysTransLogs.vue?vue&type=style&index=0&id=1ea92f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea92f55",
  null
  
)

export default component.exports